import { css } from '@emotion/core'

export const icon = css`
	:after {
		content: "\\e916";
	}
`